module.exports = __webpack_public_path__ + "static/ui4-d59e77dc34d0a858a960e0a56dfbbde8.mp3";